
import Loadable from 'react-loadable';
import Spinner from '../../components/spinner';


export default Loadable({
  loader: () => import(/* webpackChunkName: "ItemCreate"*/'./item-create'),
  loading: Spinner
});
